export class QuestionsPostRequest {
  resolutionId!: string
  body!: string
}
